import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetSemesterTest, IGetSemesterTestPapers, IGetSemesterTests, IGetTestPaperItems, ISemesterTestReq, ITestPaperParams } from '../models/semesterTest.model';
import QueryString from 'qs';

const uri = '/mgmt/semester-test';

export const getSemesterTests = (semesterCode: number): AxiosPromise<IGetSemesterTests> => {
  return axios.get(`${uri}/${semesterCode}`);
};

export const getSemesterTest = (scheduleCode: number): AxiosPromise<IGetSemesterTest> => {
  return axios.get(`${uri}/exam/${scheduleCode}`);
};

export const createSemesterTest = (semesterCode: number, data: ISemesterTestReq): AxiosPromise => {
  return axios.post(`${uri}/${semesterCode}`, data);
};

export const updateSemesterTest = (scheduleCode: number, data: ISemesterTestReq): AxiosPromise => {
  return axios.put(`${uri}/exam/${scheduleCode}`, data);
};

export const openSemesterTestResult = (scheduleCode: number): AxiosPromise => {
  return axios.put(`${uri}/exam/${scheduleCode}/open`);
};

export const getSemesterTestPapers = (scheduleCode: number): AxiosPromise<IGetSemesterTestPapers> => {
  return axios.get(`${uri}/${scheduleCode}/exam-paper`);
};

export const getTestPaperItems = (params?: ITestPaperParams): AxiosPromise<IGetTestPaperItems> => {
  let _uri = `${uri}/exam-paper/search`;
  const qsParams = QueryString.stringify(params);
  if (qsParams) _uri += `?${qsParams}`; 
  return axios.get(_uri);
};

export const createSemesterTestPaper = (scheduleCode: number, data: { examCode: number }): AxiosPromise => {
  return axios.post(`${uri}/exam-paper/${scheduleCode}`, data);
};

export const updatePaperLevels = (scheduleCode: number, examCode: number, data: { courseCode: number }[]): AxiosPromise => {
  return axios.post(`${uri}/${scheduleCode}/${examCode}/course`, data);
};
